import * as UI from 'ui';
import * as Select from 'app/area/case/selectors';
import * as appComponents from 'app/components';
import { Dummy } from 'app/infrastructure/ui/debug-render';
import * as AppEnhance from 'app/components/enhancers';
import * as UIEnhance from 'ui/common/enhancers';
import * as caseComponents from 'app/area/case/components';
import * as AddFeature from 'app/area/case/features';
import * as caseData from 'app/area/case/case-data-model';
import { SharePreset } from 'app/area/case/features';
import { ControlType, IteratorType } from 'app/infrastructure/ui';
import { ComponentIndex } from 'app/infrastructure/ui/types-uischema';
import { withCopyRiskEvaluation, withGetUiDefinition } from 'app/area/case/features/loss-potential-evaluation';

const Enhance = {...AppEnhance, ...UIEnhance};

export const reportModeComponents: ComponentIndex =  {

  [ControlType.NotImplemented]: {
    component: Dummy,
    configType: ControlType.NotImplemented
  },

  [ControlType.SectionPanel]: {
    component: Dummy,
    configType: ControlType.SectionPanel
  },

  [ControlType.View]: {
    component: UI.Paper,
    enhancers: [Enhance.withClassNames('compact')],
    configType: ControlType.View
  },

  [ControlType.LinkHeading]: {
    component: UI.LinkHeading,
    enhancers: [Enhance.withClassNames('compact')],
    selectors: [Select.urlToConnectedCase(), Select.urlToCase()],
    configType: ControlType.LinkHeading
  },

  [ControlType.HeaderPanel]: {
    component: appComponents.ReadHeaderPanel,
    enhancers: [Enhance.withClassNames('compact'), AddFeature.withSharing(SharePreset.case), withCopyRiskEvaluation(), 
      withGetUiDefinition, AddFeature.withCallsToActions, Enhance.withProperty('reloadOnCallsToActions', false)],
    selectors: [Select.headerVisibilityConfiguration, Select.casePermissions, Select.urlToCase(), Select.caseId,
      Select.templateURL, Select.sharedState, Select.lossPotentialEvaluationValues,
      Select.entityId, Select.connectedCasesMaxSequence, Select.connectedDrafts],
    configType: ControlType.HeaderPanel
  },

  [ControlType.FlexPanel]: {
    component: UI.FlexPanel,
    configType: ControlType.FlexPanel
  },

  [ControlType.Tile]: {
    component: Enhance.withLink(UI.Tile),
    configType: ControlType.Tile,
    selectors: [
      Select.urlToChildEntity,
      Select.primaryKeyFromContext(),
      Select.editDocumentItemVisibility
    ],
    enhancers: [Enhance.withProperty('showDetailsButton', false)]
  },

  [ControlType.FactBox]: {
    component: caseComponents.FactBox,
    selectors: [
      Select.caseId,
      Select.riskValues
    ],
    enhancers: [Enhance.withClassNames('compact'), AddFeature.withFileDownload(caseData.tableName.object)],
    configType: ControlType.FactBox
  },

  [ControlType.SurveyLink]: {
    component: UI.Link,
    selectors: [Select.templateURL],
    enhancers: [],
    configType: ControlType.SurveyLink
  },

  [ControlType.Link]: {
    component: UI.Link,
    selectors: [Select.domainTemplateUrl],
    enhancers: [Enhance.withSize({md: 6, lg:4, xl:3})],
    configType: ControlType.Link
  },

  [ControlType.Signature]: {
    component: UI.DisplayDate,
    selectors: [],
    enhancers: [],
    configType: ControlType.Signature
  },

  [ControlType.CompactTile]: {
    component: Enhance.withLink(UI.CompactTile),
    configType: ControlType.CompactTile,
    selectors: [
      Select.urlToChildEntity(true),
      Select.editDocumentItemVisibility
    ],
    enhancers: [Enhance.withProperty('showDetailsButton', false)]
  },

  [ControlType.CompactTileHeader]: {
    component: appComponents.CompactTileHeader,
    selectors: [Select.tileHeaderPrimaryKeyWithReportKeyLabel],
    configType: ControlType.CompactTileHeader
  },

  [ControlType.DisplayCodesStatus]: {
    component: UI.DisplayCodes,
    enhancers: [Enhance.withProperty('displayBackgroundColor', 'false'),
                Enhance.withProperty('style', 'secondary')],
    configType: ControlType.DisplayCodesStatus
  },

  [ControlType.BadgeListFileUploader]: {
    component: caseComponents.BadgeListFileUploader,
    selectors: [Select.print],
    enhancers: [AddFeature.withFileDownload(), Enhance.withProperty('clickable', false)],
    configType: ControlType.BadgeListFileUploader
  },

  [ControlType.LossPotentialEvaluation]: {
    component: caseComponents.LossPotentialEvaluation,
    selectors: [Select.primaryKeyFromContext(), Select.urlToChildEntity],
    enhancers: [Enhance.withProperty('activeChild', false)],
    configType: ControlType.LossPotentialEvaluation
  },

  [ControlType.LossPotentialEvaluationTileView]: {
    component: caseComponents.LossPotentialEvaluationTileView,
    selectors: [Select.childEntities, Select.hideLossPotentialEvaluation],
    enhancers: [Enhance.withClassNames('compact'), Enhance.withProperty('navigateToUrl', true)],
    configType: ControlType.LossPotentialEvaluationTileView
  },

  [ControlType.DetailForm]: {
    component: UI.DetailFormPanel,
    configType: ControlType.DetailForm,
    selectors: [Select.primaryKeyFromContext()]
  },

  [ControlType.TileView]: {
    component: UI.TileView,
    configType: ControlType.TileView,
    enhancers: [Enhance.withProperty('hideTextNoData', true)],
    selectors: [Select.activeChildItem],
    iterate: { type: IteratorType.DataRows }
  },

  [ControlType.CommentTileView]: {
    component: appComponents.CommentTileView,
    configType: ControlType.CommentTileView,
    enhancers: [Enhance.withSize({lg: 8}), Enhance.withClassNames('no-content-read'), Enhance.withProperty('hideTextNoData', true)],
    selectors: [Select.activeChildItem],
    iterate: { type: IteratorType.DataRows }
  },
  
  [ControlType.CategoryTileView]: {
    component: appComponents.CategoryTileView,
    configType: ControlType.CategoryTileView,
    selectors: [Select.activeChildItem],
    enhancers: [Enhance.withProperty('hideTextNoData', true)],
    iterate: { type: IteratorType.DataRows }
  },

  [ControlType.ConsequenceTypeTileView]: {
    component: appComponents.CodeSelectorTileView,
    configType: ControlType.ConsequenceTypeTileView,
    selectors: [Select.activeChildItem],
    enhancers: [Enhance.withProperty('hideTextNoData', true)],
    iterate: { type: IteratorType.DataRows }
  },

  [ControlType.SummaryTileView]: {
    component: caseComponents.SummaryTileView,
    configType: ControlType.SummaryTileView,
    selectors: [Select.activeChildItem],
    enhancers: [Enhance.withProperty('hideLabelIfNoData', true), Enhance.withProperty('hideTextNoData', true)],
    iterate: { type: IteratorType.DataRows }
  },

  [ControlType.BarrierInspectionTileView]: {
    component: caseComponents.SummaryTileView,
    configType: ControlType.BarrierInspectionTileView,
    selectors: [ Select.activeChildItem ],
    enhancers: [ Enhance.withProperty('doubleWidth', true), Enhance.withProperty('hideTextNoData', true)],
    iterate: { type: IteratorType.DataRows }
  },

  [ControlType.CauseCategoryTileView]: {
    component: appComponents.CategoryTileView,
    selectors: [Select.childEntityFieldValueAsOptions(caseData.tableName.causes, 'CauseCategory'), Select.activeChildItem],
    enhancers: [Enhance.withProperty('hideTextNoData', true)],
    configType: ControlType.CauseCategoryTileView,
    iterate: { type: IteratorType.CodeTable }
  },

  [ControlType.FileUploader]: {
    component: UI.FileUploader,
    selectors: [Select.print],
    enhancers: [AddFeature.withFileDownload(), Enhance.withProperty('hideTextNoData', true)],
    configType: ControlType.FileUploader
  },

  [ControlType.IndicatorCodeSelectorTileView]: {
    component: appComponents.CodeSelectorTileView,
    selectors: [Select.childEntityTypeKeys, Select.activeChildItem],
    enhancers: [Enhance.withProperty('hideTextNoData', true)],
    configType: ControlType.IndicatorCodeSelectorTileView,
    iterate: { type: IteratorType.DataRows }
  },

  [ControlType.ReferenceTileView]: {
    component: caseComponents.ReferenceSelectTileView,
    selectors: [Select.activeChildItem],
    configType: ControlType.ReferenceTileView,
    enhancers: [Enhance.withPrimaryKeyAsOptionIteratorId, Enhance.withSize({lg: 12}), Enhance.withProperty('hideTextNoData', true)],
    iterate: { type: IteratorType.DataRows }
  },

  [ControlType.CheckListCategoryTileView]: {
    component: appComponents.CategoryTileView,
    configType: ControlType.CheckListCategoryTileView,
    selectors: [Select.activeChildItem],
    enhancers: [Enhance.withProperty('hideTextNoData', true)],
    iterate: { type: IteratorType.DataRows }
  },

  [ControlType.ActionFactItem]: {
    component: caseComponents.ActionFactItem,
    configType: ControlType.ActionFactItem,
    selectors: [
      Select.childEntityCount([
        {
          entityPath: [{ entityType: caseData.tableName.trans }, { entityType: caseData.tableName.action }],
          propName: (caseData.columnName[caseData.tableName.action] as any).numberOfActions
        },
        {
          entityPath: [{ entityType: caseData.tableName.trans }, { entityType: caseData.tableName.action }],
          propName: (caseData.columnName[caseData.tableName.action] as any).numberOfClosedActions,
          dataTag: (caseData.columnName[caseData.tableName.action] as any).actionCompletedDate
        }]),
      Select.urlToCase(),
      Select.reportCategory
    ]
  },

  [ControlType.AssessmentFactItem]: {
    component: caseComponents.AssessmentFactItem,
    configType: ControlType.AssessmentFactItem,
    selectors: [
      Select.childEntityCount([
        {
          entityPath: [{ entityType: caseData.tableName.trans }, { entityType: caseData.tableName.assessment }],
          propName: (caseData.columnName[caseData.tableName.assessment] as any).numberOfAssessments
        }
      ]),
      Select.urlToCase()
    ]
  },

  [ControlType.AttachedFilesFactItem]: {
    component: caseComponents.AttachedFilesFactItem,
    configType: ControlType.AttachedFilesFactItem,
    selectors: [
      Select.childEntityCount([
        {
          entityPath: [{ entityType: caseData.tableName.trans }, { entityType: caseData.tableName.object }],
          propName: (caseData.columnName[caseData.tableName.object] as any).numberOfFiles
        },
        {
          entityPath: [{ entityType: caseData.tableName.trans },
                       { entityType: caseData.tableName.attachmentType, id: 2},
                       { entityType: caseData.tableName.link }],
                       propName: (caseData.columnName[caseData.tableName.link] as any).numberOfLinks
        }
      ]),
      Select.urlToCase()
    ]
  },

  [ControlType.BowtieFactItem]: {
    component: caseComponents.BowtieFactItem,
    configType: ControlType.BowtieFactItem,
    selectors: [Select.bowtieSupported, Select.caseId]
  },

  [ControlType.CausesFactItem]: {
    component: caseComponents.CausesFactItem,
    configType: ControlType.CausesFactItem,
    selectors: [ 
      Select.childEntityCount([
        {
          entityPath: [{ entityType: caseData.tableName.trans }, { entityType: caseData.tableName.causes }],
          propName: (caseData.columnName[caseData.tableName.causes] as any).numberOfCauses
        }
      ]),
      Select.urlToCase()
    ]
  },

  [ControlType.CommentsFactItem]: {
    component: caseComponents.CommentsFactItem,
    configType: ControlType.CommentsFactItem,
    selectors: [
      Select.childEntityCount([
        {
          entityPath: [{ entityType: caseData.tableName.trans }, { entityType: caseData.tableName.comment }],
          propName: (caseData.columnName[caseData.tableName.comment] as any).numberOfComments
        }
      ]),
      Select.urlToCase()
    ]
  },

  [ControlType.ConnectedCasesFactItem]: {
    component: caseComponents.ConnectedCasesFactItem,
    configType: ControlType.ConnectedCasesFactItem,
    selectors: [
      Select.connectedCasesIdsIrrespectiveOfConnectionType,
      Select.urlToCase()
    ]
  },

  [ControlType.ConsequencesFactItem]: {
    component: caseComponents.ConsequencesFactItem,
    configType: ControlType.ConsequencesFactItem,
    selectors: [
      Select.riskValues,
      Select.childEntityValuesAsProperty('childValueItems', [
        {
          entityPath: [{ entityType: caseData.tableName.trans }, { entityType: caseData.tableName.consequences }],
          propName: (caseData.columnName[caseData.tableName.consequences] as any).actConsConsequenceIcons
        }]),
      Select.urlToCase()
    ]
  },

  [ControlType.ChecklistFactItem]: {
    component: caseComponents.ChecklistFactItem,
    configType: ControlType.ChecklistFactItem,
    selectors: [
      Select.checklistValues,
      Select.urlToCase()
    ]
  },

  [ControlType.IntegrityStatusFactItem]: {
    component: caseComponents.IntegrityStatusFactItem,
    configType: ControlType.IntegrityStatusFactItem,
    selectors: [
      Select.integrityValues,
      Select.urlToCase()
    ]
  },

  [ControlType.IntegrityStatusBarrierEvalFactItem]: {
    component: caseComponents.IntegrityStatusBarrierEvalFactItem,
    configType: ControlType.IntegrityStatusBarrierEvalFactItem,
    selectors: [
      Select.integrityStatusBarrierEvalValues,
      Select.urlToCase()
    ]
  },

  [ControlType.InvolvedDrugFactItem]: {
    component: caseComponents.InvolvedDrugFactItem,
    configType: ControlType.InvolvedDrugFactItem,
    selectors: [
      Select.childEntityCount([
        {
          entityPath: [{ entityType: caseData.tableName.trans }, { entityType: caseData.tableName.involvedDrug }],
          propName: (caseData.columnName[caseData.tableName.involvedDrug] as any).numberOfInvolvedDrugs
        }
      ]),
      Select.urlToCase()
    ]
  },

  [ControlType.InvolvedPersonFactItem]: {
    component: caseComponents.InvolvedPersonFactItem,
    configType: ControlType.InvolvedPersonFactItem,
    selectors: [
      Select.childEntityCount([
        {
          entityPath: [{ entityType: caseData.tableName.trans }, { entityType: caseData.tableName.involvedPerson }],
          propName: (caseData.columnName[caseData.tableName.involvedPerson] as any).numberOfInvolvedPersons
        }
      ]),
      Select.urlToCase()
    ]
  },

  [ControlType.ResidualRiskFactItem]: {
    component: caseComponents.ResidualRiskFactItem,
    configType: ControlType.ResidualRiskFactItem,
    selectors: [
      Select.residualRiskValues,
      Select.urlToCase()
    ]
  },

  [ControlType.RiskFactItem]: {
    component: caseComponents.RiskFactItem,
    configType: ControlType.RiskFactItem,
    selectors: [
      Select.riskValues,
      Select.urlToCase()
    ]
  },

  [ControlType.FactItemPanel]: {
    component: caseComponents.FactItemPanel,
    configType: ControlType.FactItemPanel
  }
};
